export const loginConfig = () => {
    let BLANK_VALIDATION = " Username and Password field cannot be blank";
    let AUTHENTICATION_FAILED = "Something went wrong,try again";
    let EMAIL_BLANK = "Enter email Id";
    let INVLID_EMAIL = "Enter valid email Id";
    let BLANK_PASSWORD = "Enter Password";
    let COMMON_ERROR = "Enter valid email and password";
    let WRONG_USER = "Enter valid credentials";
    return {
   
      BLANK_VALIDATION,
      AUTHENTICATION_FAILED,
      EMAIL_BLANK,
      INVLID_EMAIL,
      BLANK_PASSWORD,
      COMMON_ERROR,
      WRONG_USER
    };
  };